import React from 'react';
import { motion } from 'framer-motion';
import { CircleDotIcon, GaugeIcon, MapIcon, OctagonPauseIcon, RouteIcon, TriangleAlertIcon } from 'lucide-react';
const SIGNALS = [{
  icon: RouteIcon,
  label: 'Recorrido',
  text: 'Traza completa del viaje, tramo por tramo.'
}, {
  icon: CircleDotIcon,
  label: 'Posición',
  text: 'Ubicación actual de la unidad en ruta.'
}, {
  icon: OctagonPauseIcon,
  label: 'Paradas',
  text: 'Detenciones, duración y coincidencia con la planificación.'
}, {
  icon: MapIcon,
  label: 'Desvíos',
  text: 'Diferencias contra la ruta prevista.'
}, {
  icon: TriangleAlertIcon,
  label: 'Contingencias',
  text: 'Eventos que requieren decisión operativa.'
}, {
  icon: GaugeIcon,
  label: 'Cumplimiento',
  text: 'Comparación entre lo comprometido y lo ejecutado.'
}];
export function SatelliteView() {
  return <div className="grid gap-px overflow-hidden border border-white/10 bg-white/10 lg:grid-cols-[1.15fr_1fr]" data-id="element-234" data-mp="girhhqlh5jf8">
      <div className="relative min-h-[300px] bg-graphite-900 p-6" data-id="element-235" data-mp="bpomde11u1wx">
        <svg viewBox="0 0 400 300" className="h-full w-full" role="img" aria-label="Esquema de recorrido monitoreado con paradas y desvío detectado" data-id="element-236" data-mp="1q6okjz0vb7r7">
          <g stroke="#FFFFFF" strokeOpacity="0.06" data-id="element-237" data-mp="1uamjo9q70ik9">
            {Array.from({
            length: 9
          }).map((_, i) => <line key={`h${i}`} x1="0" y1={i * 36} x2="400" y2={i * 36} data-id="element-238" data-mp="1gfapq4jv2w4e" data-mpi={i} />)}
            {Array.from({
            length: 11
          }).map((_, i) => <line key={`v${i}`} x1={i * 40} y1="0" x2={i * 40} y2="300" data-id="element-239" data-mp="16hw9o61uo9cm" data-mpi={i} />)}
          </g>
          <motion.path d="M30 250 C 90 230, 110 170, 165 160 S 250 150, 290 100 S 350 70, 372 44" fill="none" stroke="#42906E" strokeWidth="2.5" initial={{
          pathLength: 0
        }} whileInView={{
          pathLength: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-240" data-mp="1bj3mijiunyq5" />
          <motion.path d="M165 160 C 200 196, 236 196, 258 168" fill="none" stroke="#EEAE43" strokeWidth="2" strokeDasharray="4 4" initial={{
          pathLength: 0,
          opacity: 0
        }} whileInView={{
          pathLength: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.26,
          delay: 0.18,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-241" data-mp="2wuc1vnbgleay" />
          <circle cx="30" cy="250" r="5" fill="#FFFFFF" data-id="element-242" data-mp="2gis3g6o8a6d3" />
          <circle cx="165" cy="160" r="4" fill="#74AF93" data-id="element-243" data-mp="3e4z5b8t5dklr" />
          <circle cx="290" cy="100" r="4" fill="#74AF93" data-id="element-244" data-mp="3e6iksx6zbrmh" />
          <circle cx="258" cy="168" r="4.5" fill="#EEAE43" data-id="element-245" data-mp="396xkojg2pd86" />
          <circle cx="372" cy="44" r="5" fill="#DC9016" data-id="element-246" data-mp="34emjld9ljle1" />
          <text x="40" y="266" fill="#CFD6D2" fontSize="10" data-id="element-247" data-mp="34d1o9lfgjyf4">Origen</text>
          <text x="264" y="186" fill="#F6C878" fontSize="10" data-id="element-248" data-mp="2zf08b9dbwf7v">Desvío detectado</text>
          <text x="316" y="36" fill="#FFFFFF" fontSize="10" data-id="element-249" data-mp="q2r5ul6156r">Entrega</text>
        </svg>
        <span className="absolute right-5 top-5 border border-accent-400/40 bg-accent-500/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.14em] text-accent-300" data-id="element-250" data-mp="3s3yrm9t6tner">
          Demo
        </span>
      </div>

      <div className="bg-graphite-800 p-6 md:p-8" data-id="element-251" data-mp="8adec022o4h8">
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-accent-400" data-id="element-252" data-mp="8b59xavo627i">Multiplataforma de seguimiento</p>
        <p className="mt-4 text-sm leading-relaxed text-mist-200" data-id="element-253" data-mp="i788y7v85kq8">
          El modelo tecnológico puede integrar distintos proveedores de monitoreo satelital dentro de una misma vista
          operacional, sin obligar al cliente a cambiar el proveedor que ya utiliza.
        </p>
        <dl className="mt-7 grid gap-5 sm:grid-cols-2" data-id="element-254" data-mp="vywnehsy4lad">
          {SIGNALS.map(s => <div key={s.label} data-id="element-255" data-mp="w192mn7bkhjq">
              <dt className="flex items-center gap-2 text-sm font-semibold text-white" data-id="element-256" data-mp="10yiz2mt4lth2">
                <s.icon className="h-4 w-4 text-brand-300" aria-hidden="true" data-id="element-257" data-mp="15xcfoo3pm0lg" />
                {s.label}
              </dt>
              <dd className="mt-1.5 text-xs leading-relaxed text-mist-300" data-id="element-258" data-mp="19zpl1bejnwhp">{s.text}</dd>
            </div>)}
        </dl>
      </div>
    </div>;
}